// extracted by mini-css-extract-plugin
module.exports = {"image":"SuperPower_image__2I5LD","card":"SuperPower_card__3CyfN","cardTitle":"SuperPower_cardTitle__Ti3Z9","HvrGrowShadow":"SuperPower_HvrGrowShadow__joTUc"};